import Icons from "../../assets/icons/index.js";
import { FaRegUser } from "react-icons/fa";
import {
  Navbar,
  AdminprofileImage,
  Loader,
  Btn,
  AnimateSpin,
  InputField,
  FormInput,
  MainHeading,
} from "../../components/index";
import profileFunction from "./index.function.js";
import { fontSizes } from "../../constants/constants.js";
import { ReactSVG } from "react-svg";
const Profile = () => {
  const {
    register,
    setValue,
    getValues,
    control,
    errors,
    loadingToapi,
    onChangeImage,
    handleFormSubmit,
    isLoading,
    loading,
    uploadFileData,
    userData,
    TextWeight,
  } = profileFunction();
  return (
    <div className="flex">
      <Navbar />
      <div className="w-full px-4 py-3 sm:px-12 sm:py-10 h-screen overflow-y-scroll hide-scrollbar">
        <AdminprofileImage />
        <div>
          <MainHeading
            Icon={Icons.ProfileblackIcon}
            heading={"Profile"}
            paragraph={
              "Check out your account details or update your personal details, contact information or password here."
            }
          />
          <form className="px-2" onSubmit={handleFormSubmit}>
            <div className="">
              {isLoading ? (
                <AnimateSpin />
              ) : (
                <div className="flex items-start flex-col lg:flex-row">
                  <div className="w-full text-left sm:text-left lg:text-center 2xl:flex 2xl:justify-center 2xl:items-start lg:w-[40%] lg:pr-5 pb-5 lg:pb-0 xl:px-10 pt-5 ">
                    <div className="bg-primary rounded-full flex justify-center items-center w-44 h-44 sm:w-56 sm:h-56 xl:w-80 xl:h-80 relative">
                      <div className="flex justify-center items-center w-[95%] h-[95%]">
                        <div className="flex justify-center items-center w-full h-full">
                          {uploadFileData || userData?.data?.image ? (
                            <img
                              className="rounded-full w-full h-full"
                              src={uploadFileData || userData?.data?.image}
                              alt="User"
                            />
                          ) : (
                            <FaRegUser className="w-[60%] h-[60%]" />
                          )}
                        </div>
                      </div>
                      <button
                        disabled={loading}
                        className={`absolute bottom-3.5 sm:bottom-6 lg:bottom-1 xl:bottom-7 flex justify-center items-center right-3 sm:right-4 lg:right-8 rounded-full w-8 h-8 sm:w-8 sm:h-8 lg:w-12 lg:h-12 bg-primary shadow-custom-gray ${
                          loading ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                        onClick={() =>
                          document.getElementById("profileImg").click()
                        }
                        type="button"
                      >
                        {loading ? (
                          <Loader isprimary={false} />
                        ) : (
                          <ReactSVG
                            src={Icons.ProfileImageEditImg}
                            beforeInjection={(svg) => {
                              svg.classList.add("w-4", "md:w-6", "h-auto");
                            }}
                          />
                        )}
                      </button>
                      <input
                        id="profileImg"
                        type="file"
                        className="hidden"
                        name="image"
                        onChange={(e) => onChangeImage(e)}
                      />
                    </div>
                    {/* {errors?.files && (
                      <span style={{ color: "red" }}>
                        {errors?.files?.message}
                      </span>
                    )} */}
                  </div>
                  <div className="w-full">
                    <div className="relative mt-1.5 xl:mt-5">
                      <FormInput
                        control={control}
                        userData={userData}
                        errors={errors}
                        name="fullname"
                        type="text"
                        placeholder="Full Name"
                        label="Full Name"
                        icon={Icons.Userinputicons}
                        iconStyle={"w-5 h-5 lg:h-6 lg:w-7 2xl:w-8 2xl:h-7"}
                      />
                    </div>
                    <div className="relative mt-1.5 xl:mt-5">
                      <FormInput
                        control={control}
                        userData={userData}
                        name="email"
                        type="text"
                        placeholder="Email Address"
                        label="Email Address"
                        icon={Icons.EmailIcons}
                        iconStyle={"w-5 h-5 lg:h-5 lg:w-6 2xl:w-7 2xl:h-6"}
                        errors={errors}
                      />
                    </div>
                    <div className="relative mt-1.5 xl:mt-5">
                      <FormInput
                        control={control}
                        userData={userData}
                        name="phone"
                        type="tel"
                        placeholder="Phone Number"
                        label="Phone Number"
                        icon={Icons.ClliIcons}
                        iconStyle={"w-5 h-5 lg:h-5 lg:w-6 2xl:w-7 2xl:h-6"}
                        errors={errors}
                      />
                    </div>
                    <div className="relative mt-1.5 xl:mt-5 ">
                      <InputField
                        type="password"
                        name="password"
                        placeholder="Password"
                        {...register("password", {
                          required: "Password is required",
                          // pattern: {
                          //     value: /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,16}$/,
                          //     message:
                          //         "Password must be at least 8 characters long, include an uppercase letter, a number, and a special character.",
                          // },
                        })}
                        onChange={(value) => setValue("password", value)}
                        isPassword={true}
                        icon={Icons.lockIcons}
                        iconPasswordVisible={Icons.showPasswordIcon}
                        iconPasswordHidden={Icons.hidePasswordIcon}
                        iconStyle={"w-5 h-5 lg:h-6 lg:w-7 2xl:w-8 2xl:h-7"}
                        errors={errors}
                      />
                    </div>
                    <div className="relative mt-1.5 xl:mt-5 ">
                      <InputField
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm Password"
                        {...register("confirmPassword", {
                          required: "Confirm Password is required",
                          validate: (value) =>
                            value === getValues("password") ||
                            "Passwords do not match",
                        })}
                        onChange={(value) => setValue("confirmPassword", value)}
                        isPassword={true}
                        icon={Icons.lockIcons}
                        iconPasswordVisible={Icons.showPasswordIcon}
                        iconPasswordHidden={Icons.hidePasswordIcon}
                        iconStyle={"w-5 h-5 lg:h-6 lg:w-7 2xl:w-8 2xl:h-7"}
                        errors={errors}
                      />
                    </div>
                  </div>
                </div>
              )}
              <Btn
                type={"submit"}
                isDisabled={loadingToapi || loading}
                loading={loadingToapi}
                isprimary={false}
                weight={TextWeight.Raleway_SemiBold}
                textSize={fontSizes.h18}
                text={"Update"}
                color="text-white"
                hover={"hover:text-primary hover:bg-white hover:border-primary"}
                bgColor={"bg-primary border-transparent"}
                className={"ml-auto my-3 sm:my-5 lg:my-8"}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default Profile;
